import { SPACING } from '@alto/design-library-tokens';
import { Button, Card, LgPadding, Tag } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useEffect } from 'react';
import styledNative from 'styled-components/native';
import { selectUser } from '~shared/actions/ui/users';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { getCurrentUserID } from '~shared/features/users/selectors/getUsers';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import InsuranceCard from '~web/images/insuranceCardFlat@2x.png';

const CustomCard = styledNative(Card)`
  margin: 0 0 0;
  z-index: 0;
`;

type Props = {
  readonly userID: number;
  readonly name: string | null | undefined;
};

export const NeedsInsuranceCard = ({ userID, name }: Props) => {
  const tag = (
    <Tag
      label="ACTION REQUIRED"
      type="warning"
    />
  );
  const { trackEvent } = useAnalytics();
  const { navigate } = useNavigation();
  const dispatch = useDispatchShared();
  const currentUserID = useSelectorShared(getCurrentUserID);

  useEffect(() => {
    trackEvent({
      event: EVENTS.ADD_INSURANCE_VIEWED,
    });
  }, [trackEvent]);

  const label = 'Outdated insurance';
  const messagePerson = (userID !== currentUserID && !!name && `${name}'s `) || 'your ';
  const title = (userID !== currentUserID && !!name ? `${name}'s ` : '') + label;

  const handleUpdateInsurance = () => {
    trackEvent({ event: EVENTS.ADD_INSURANCE_CLICKED });
    dispatch(selectUser(userID));
    navigate('RouteInsuranceSection', { userID });
  };

  return (
    <CustomCard
      title={title}
      description={`Get the most out of your prescription benefits by updating ${messagePerson}insurance info.`}
      illustrationSrc={InsuranceCard}
      illustrationAccessibilityLabel={IMG_ALT_TEXTS.insuranceCard}
      tag={tag}
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Button
          onPress={handleUpdateInsurance}
          type="primary"
          width="full"
        >
          Update now
        </Button>
      </LgPadding>
    </CustomCard>
  );
};
